// extracted by mini-css-extract-plugin
export default {"name":"AssetVersionRow__name-UVLzn","description":"AssetVersionRow__description-pbMIn","menu":"AssetVersionRow__menu-h3tY5"};